import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CloseCircleTwoTone";
import AntdIcon from '../components/AntdIcon';
var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CloseCircleTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CloseCircleTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CloseCircleTwoTone';
}
export default RefIcon;